import { cookie } from '@tencent/qd-lib';
import pageInit from './pageInit.js';
import { getRobotIdFromCookie } from './tools';

function handler(menu, ids, subIds) {
    const result = menu.reduce((prev, cur) => {
        const { id, subMenu } = cur;
        // 要处理 subMenu 的二级菜单，不处理原样返回
        if (ids.includes(id)) {
            // 三级菜单过滤
            const temp = subMenu.filter(({ id: subId }) => subIds.includes(subId));
            if (temp.length > 0) {
                prev.push({
                    ...cur,
                    subMenu: temp,
                });
            }
        } else {
            prev.push(cur);
        }
        return prev;
    }, []);
    return result;
}

function robotMenuHandle(menu) {
    if (getRobotIdFromCookie() == '0') return handler(menu, [], []);
    return pageInit.fetchMenu({ kfuin: cookie.get('corp_uin') })
        .then(({ code, data: { menuIds = [], subMenuIds = [] } }) => {
            const result = 0 === code ? handler(menu, menuIds, subMenuIds) : handler(menu, [], []);
            return new Promise(resolve => resolve(result));
        })
        .catch(() => new Promise(resolve => resolve(menu || [])));
}

export default robotMenuHandle;
